import { appContextStore } from './app-context.state.js';

let appContextProvider = Object.freeze({
  async getPageAuthors() {
    return void 0;
  }
});
function configureAppContextProvider(nextProvider) {
  const getPageAuthors = async (product, page) => {
    const authors = await nextProvider.getPageAuthors(product, page);
    appContextStore.dispatch(appContextStore.actions.setAuthors(authors));
    return authors;
  };
  appContextProvider = Object.freeze({
    ...nextProvider,
    getPageAuthors
  });
}

export { appContextProvider, configureAppContextProvider };
//# sourceMappingURL=app-context.provider.js.map
